export default __webpack_public_path__ + "static/employee-20f2b823fc7fdfd82ff646817467065d.jpeg";